import { useCallback } from 'react';
import { useStore } from 'react-redux';

export function useCapability() {
    const store = useStore();
    const hasCapability = useCallback(
        cap => {
            const capabilities = store.getState().user.user?.capabilities;
            return !cap || capabilities?.includes(cap);
        },
        [store]
    );
    return {
        hasCapability,
        capabilities: store.getState().user?.user?.capabilities
    };
}
